<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12 position-relative z-index-2">
        <div class="row">
          <div class="col-lg-12">            
            <div class="row mt-3" style="margin-bottom: 1.1rem">
              <div class="col-lg-4 col-sm-12">
                <EntitySummaryCard :title="$t('key_orders_prepared_yesterday')" :value="orders" :icon-numero="{
                  component: 'fa fa-shopping-bag',
                  background: iconBackground,
                }" :icon-unit="{
                  component: 'fa fa-book',
                  background: iconBackground,
                }" />
              </div>
              <div class="col-lg-4 col-sm-12">
                <EntitySummaryCard :title="$t('key_ordersBack_completed_yesterday')" :value="ordersBack" :icon-numero="{
                  component: 'fa fa-reply-all',
                  background: iconBackground,
                }" :icon-unit="{
                  component: 'fa fa-book',
                  background: iconBackground,
                }" />
              </div>
              <div class="col-lg-4 col-sm-12">
                <EntitySummaryCard :title="$t('key_purchases_completed_yesterday')" :value="purchases" :icon-numero="{
                  component: 'ni ni-cart',
                  background: iconBackground,
                }" :icon-unit="{
                  component: 'fa fa-book',
                  background: iconBackground,
                }" />
              </div>               
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <PendingOrderStock />
          </div>
          <div class="col-lg-4">
            <PendingProductStock />
          </div>
          <div class="col-lg-4">
            <EntitiesNotRegistered />
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4 row">
      <div class="col-lg-12">
        <!-- line chart -->
        <div class="card z-index-2">
          <gradient-line-chart id="chart-line" :title="$t('key_stock_analytics')"  :chart="{
            labels: warehouseLabels,
            datasets: datasets,
          }" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  import EntitySummaryCard from "../../examples/Cards/EntitySummaryCard.vue";
  // import ReportsBarChart from "../../examples/Charts/ReportsBarChart.vue";
  import GradientLineChart from "../../examples/Charts/GradientLineChart.vue";
  import PendingOrderStock from './components/PendingOrderStock.vue';
  import PendingProductStock from './components/PendingProductStock.vue';
  import EntitiesNotRegistered from './components/EntitiesNotRegistered.vue';

  import US from "@/assets/img/icons/flags/US.png";
  import DE from "@/assets/img/icons/flags/DE.png";
  import GB from "@/assets/img/icons/flags/GB.png";
  import BR from "@/assets/img/icons/flags/BR.png";

  // import Globe from "../../examples/Globe.vue";
  import {
    faHandPointer,
    faUsers,
    faCreditCard,
    faScrewdriverWrench,
  } from "@fortawesome/free-solid-svg-icons";
  import moment from "moment"

  export default {
    name: "DashboardDefault",
    components: {
      // ReportsBarChart,
      GradientLineChart,
      PendingOrderStock,
      PendingProductStock,
      EntitySummaryCard,
      EntitiesNotRegistered
      // Globe,
    },
    data() {
      return {
        faHandPointer,
        faUsers,
        faCreditCard,
        faScrewdriverWrench,
        iconBackground: "bg-gradient-success",
        US,
        DE,
        BR,
        GB,
        ordersReceived: 0,
        ordersFinalized: 0,
        unitsReceived: 0,
        unitsFinalized: 0,
        warehouseLabels: [],
        datasets: []
      };
    },
    computed: {
      orders() {
        return this.$store.state.dashboard.orders.data;
      },
      ordersBack() {
        return this.$store.state.dashboard.ordersBack.data;
      },
      purchases() {
        return this.$store.state.dashboard.purchases.data;
      },
      warehousesStocks() {
        return this.$store.state.dashboard.warehousesStocks.data;
      },
    },
    watch: {
      warehousesStocks() {
        let warehousesStocks = this.$store.state.dashboard.warehousesStocks.data;

        const  { start, end, items } = warehousesStocks

        if (start && end) {
          const startDate = moment(start);
          const endDate = moment(end);

          let range = this.$dateUtils.getDaysBetweenDates(startDate, endDate)

          this.warehouseLabels = range.map(date => {
            return date.format('DD/MM');
          })
          this.datasets = [ ...items ]
        }
      },
    },
    mounted() {
      this.$store.commit("dashboard/getOrders");
      this.$store.commit("dashboard/getOrdersBack");
      this.$store.commit("dashboard/getPurchases");
      this.$store.commit("dashboard/getWarehousesStock");
      // this.$store.commit("dashboard/getProductStock");
    }
  };

</script>
